var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "16px",
    viewBox: "0 0 22 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C7E6BEFF-A74E-4E99-B23A-DD22B4B262ED") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "14-Sixtbook-employee-communication",
    transform: "translate(-789.000000, -736.000000)",
    fill: "#191919",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Popup",
    transform: "translate(400.000000, 145.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uploadfile",
    transform: "translate(30.000000, 574.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/24x24/ico_co2",
    transform: "translate(358.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23,15.0790378 C23,17.7823588 20.6969387,20 17.8813824,20 L6.11861761,20 C3.29419819,20 1,17.7997295 1,15.0790378 C1,12.6263074 2.87728379,10.5724297 5.34649108,10.2061059 C5.45170769,6.77044874 8.40516694,4 12,4 C15.5948331,4 18.5482923,6.77044874 18.6535089,10.2061059 C21.1227162,10.5724297 23,12.6263074 23,15.0790378 Z M6.27250964,11.8810811 C4.45692737,11.8810811 3,13.2548901 3,14.9405405 C3,16.6171309 4.47368944,18 6.27250964,18 L17.7274904,18 C19.5430726,18 21,16.626191 21,14.9405405 C21,13.2639502 19.5263106,11.8810811 17.7274904,11.8810811 L16.6479402,11.8810811 L16.7110377,11.3778054 L16.7641326,10.9544151 C16.7828143,10.8141719 16.7866738,10.7091457 16.7866738,10.4679537 C16.7866738,8.00062973 14.6546521,6 12.0131666,6 C9.37168119,6 7.23965953,8.00062973 7.23965953,10.4679537 C7.23965953,10.7091457 7.24351897,10.8141719 7.26262904,10.9577282 L7.37839308,11.8810811 L6.27250964,11.8810811 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoUpload);
export default __webpack_public_path__ + "static/media/ico_upload.bef719e37e5216cf8ad5a2354310f2f4.svg";
export { ForwardRef as ReactComponent };